<script>
export default {
  props: ['roster'],
}
</script>

<template>
  <div class="input-group">
    <input class="form-control squad-name mb-2" v-model="roster.name" @keyup="$emit('change-name')"/>
  </div>
</template>
